import { Tabs } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

export type CompetenciesTab = 'competencies' | 'profiles' | 'levels' | 'translations';

const TABS: CompetenciesTab[] = ['competencies', 'profiles', 'levels', 'translations'];

type CompetenciesTabsProps = {
    activeTab: CompetenciesTab;
    onTabChange: (tab: CompetenciesTab) => void;
};

export const CompetenciesTabs = ({ activeTab, onTabChange }: CompetenciesTabsProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'scrollbar-glass w-full overflow-x-auto px-4 md:px-0'}>
            <Tabs
                activeKey={activeTab}
                onChange={(key) => onTabChange(key as CompetenciesTab)}
                items={TABS.map((tab) => ({
                    key: tab,
                    label: t(`competencies.tabs.${tab}`),
                    dataTestId: `competencies-tab-${tab}`,
                }))}
                className={'w-fit border-gray-300'}
            />
        </div>
    );
};
